import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Camera } from "lucide-react";

/**
 * Floating Camera Button - REMOVED: Camera functionality now in MobileBottomNav "+" button
 * This component is kept as a no-op to avoid import errors
 */
const CameraFloatingButton = () => null;

export default CameraFloatingButton;
